import {
  checkUrlForCategory,
  updateUrlWithCategory,
} from "../../07-libs/categoryUrlHash.js";

function initializeDownloadsSelectCategories() {
  // Get the download items
  const downloadItems = document.querySelectorAll(".downloads");
  // Exit if there are no download items
  if (!downloadItems.length) return;

  function listenForCategoryClick(event) {
    // Get the clicked element
    const clickedElement = event.target;
    // Exit if the clicked element is not a category
    if (!clickedElement.classList.contains("downloads__category")) return;
    // Make sure the selected category is not active
    if (clickedElement.classList.contains("active")) return;
    // Get the category uid
    const categoryUid = clickedElement.dataset.category;
    // Get the complete download item
    const downloadItem = clickedElement.closest(".downloads");
    // Update the category select
    updateCategorySelect(categoryUid, downloadItem);
    // Update the category buttons
    updateCategoryButtons(categoryUid, downloadItem);
    // Update the category items
    updateCategoryItems(categoryUid, downloadItem);
  }

  function categorySelectChange(event) {
    // Get the select element
    const selectElement = event.target;
    // Get the selected category uid
    const categoryUid = selectElement.value;
    // Get the complete download item
    const downloadItem = selectElement.closest(".downloads");
    // Update the category buttons
    updateCategoryButtons(categoryUid, downloadItem);
    // Update the category items
    updateCategoryItems(categoryUid, downloadItem);
  }

  function updateCategorySelect(categoryUid, downloadItem) {
    // Get the select element
    const selectElement = downloadItem.querySelector(
      ".downloads__select-field"
    );
    // Update the selected option
    selectElement.value = categoryUid;
  }

  function updateCategoryButtons(categoryUid, downloadItem) {
    // Get the category buttons
    const categoryButtons = downloadItem.querySelectorAll(
      ".downloads__category"
    );
    // Loop over the category buttons
    categoryButtons.forEach((categoryButton) => {
      // Get the category uid
      const categoryButtonUid = categoryButton.dataset.category;
      // Check if the category button is the same as the selected category
      if (categoryButtonUid === categoryUid) {
        // Add the active class
        categoryButton.classList.add("active");
      } else {
        // Remove the active class
        categoryButton.classList.remove("active");
      }
    });
  }

  function updateCategoryItems(categoryUid, downloadItem) {
    // Get the category
    const categoryitem = downloadItem.querySelector(
      `.downloads__category[data-category="${categoryUid}"]`
    );
    if (categoryitem) {
      // Add the hashtag to the url
      updateUrlWithCategory(categoryitem.textContent);
    }
    // Get the category files
    const categoryFiles = downloadItem.querySelectorAll(".downloads__files");
    // Loop over the category items
    categoryFiles.forEach((filesItem) => {
      // Get the category uid
      const filesItemUid = filesItem.dataset.category;
      // Check if the category item is the same as the selected category
      if (filesItemUid === categoryUid) {
        // Add the active class
        filesItem.classList.add("active");
        return;
      }
      // Remove the active class
      filesItem.classList.remove("active");
    });
  }

  function updateCategoryFromUrl() {
    // Get the categories for each download item
    const downloadCategories = document.querySelectorAll(
      ".downloads__category"
    );
    // Exit if there are no categories
    if (!downloadCategories.length) return;
    const categoryMatched = checkUrlForCategory(downloadCategories);
    if (!categoryMatched) return;
    // Get the category uid
    const categoryUid = categoryMatched.dataset.category;
    // Get the complete download item
    const downloadItem = categoryMatched.closest(".downloads");
    // Update the category select
    updateCategorySelect(categoryUid, downloadItem);
    // Update the category buttons
    updateCategoryButtons(categoryUid, downloadItem);
    // Update the category items
    updateCategoryItems(categoryUid, downloadItem);
  }

  // Add event listeners to the download items
  downloadItems.forEach((downloadItem) => {
    // Make sure the download item has categories
    const downloadCategories = downloadItem.querySelectorAll(
      ".downloads__category"
    );
    // Exit if there are no categories
    if (!downloadCategories.length) return;
    // Check for clicks on the category buttons
    downloadItem.addEventListener("click", listenForCategoryClick);
    // Also listen for changes of the select element
    const selectElement = downloadItem.querySelector(".downloads__select");
    selectElement.addEventListener("change", categorySelectChange);
  });

  updateCategoryFromUrl();
}

export default initializeDownloadsSelectCategories;
